import { render, staticRenderFns } from "./TabMembers.vue?vue&type=template&id=4ff7bd53"
import script from "./TabMembers.vue?vue&type=script&lang=js"
export * from "./TabMembers.vue?vue&type=script&lang=js"
import style0 from "./TabMembers.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports